import { createStandaloneToast } from '@chakra-ui/react';
import axios from 'axios';
import { UPLOAD_FILES_STATUS } from 'helpers/enum';
import { UploadService } from 'services/upload/upload.service';
import { SaveUploadedFilesResponse } from 'services/upload/upload.type';
import { call, put, takeEvery } from 'typed-redux-saga';
import {
  CompleteUploadFileAction,
  StartUploadAction,
  UpdateFilesAction,
} from 'types/actions/upload';

import { taskAction, translationAction, uploadAction } from '../actions';
import { uploadConstant } from '../actionTypes';

const { toast } = createStandaloneToast();

const getBlobUrl = function* ({ payload }: UpdateFilesAction) {
  try {
    const res = yield* call(() => {
      return UploadService.getUploadBlobStorageUrl();
    });
    if (!res?.link) {
      toast({
        title: `Error uploading file`,
        status: 'error',
        position: 'bottom-right',
        isClosable: true,
      });
    } else {
      yield* put(uploadAction.updateBlobUrl(res.link));
      yield* put(uploadAction.updateFiles(payload));
      yield* put(uploadAction.updateUploadStatus(UPLOAD_FILES_STATUS.UPLOADING));
      yield* put(uploadAction.updateUploadingStats(payload?.length));
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error?.response?.data?.error_message) {
      toast({
        title: error?.response?.data?.error_message,
        status: 'error',
        position: 'bottom-right',
        isClosable: true,
      });
    }
  }
};

const startUploadFiles = function* ({ payload }: StartUploadAction) {
  yield* put(uploadAction.getUploadUrl(payload));
};

const completeUploadFile = function* ({ payload }: CompleteUploadFileAction) {
  const res: SaveUploadedFilesResponse = yield* call(() => {
    return UploadService.saveUploadedFile(
      {
        summary_id: payload.isTaskUpload ? payload.task_id : null,
        use_for_summary: payload.isTaskUpload,
      },
      payload.files
    );
  });
  if (res.summary_id) {
    yield* put(
      taskAction.updateCurrentTask({
        task_id: res.summary_id,
        type: '',
      })
    );
    yield* put(taskAction.updateTemporaryTaskId(res.summary_id));
  }
  if (res.files) {
    yield* put(translationAction.updateFileStatus(res.files?.[0]));
  }
};

const completeUpload = function* () {
  yield* put(uploadAction.updateUploadStatus(UPLOAD_FILES_STATUS.FINISH));
};

const uploadFile = function* () {
  yield* put(uploadAction.uploadSuccess());
};

export const watchGetUploadUrl = function* () {
  yield* takeEvery(uploadConstant.GET_UPLOAD_URL, getBlobUrl);
};

export const watchStartUpload = function* () {
  yield* takeEvery(uploadConstant.START_UPLOAD, startUploadFiles);
};

export const watchUploadFile = function* () {
  yield* takeEvery(uploadConstant.UPLOAD_FILE, uploadFile);
};

export const watchCompleteUpload = function* () {
  yield* takeEvery(uploadConstant.COMPLETE_UPLOAD, completeUpload);
};

export const watchCompleteUploadFile = function* () {
  yield* takeEvery(uploadConstant.COMPLETE_UPLOAD_FILE, completeUploadFile);
};
